module.exports = __webpack_public_path__ + "static/media/twitter.98e10db7.png";